// src/data.js

export const projects = [
    {
      title: "Californila.com",
      subtitle: "WordPress + WooCommerce",
      description:
        "Let Californila make your purchases, so you can get more of what the US has to offer!",
      image: "./images/californila.com.png",
      link: "http://californila.com/",
    },
    {
      title: "Kee Wah Bakery Los Angeles",
      subtitle: "WordPress + WooCommerce",
      description:
        "Kee Wah was originally founded in Hong Kong in 1938. The Company is well known in Hong Kong and overseas for its signature products.",
      image: "./images/keewah.us.png",
      link: "https://keewah.us/",
    },
    {
      title: "Data Gateway Philippines",
      subtitle: "WordPress + Elementor",
      description:
        "Get top-grade content services with agile delivery from Data Gateway Philippines",
      image: "./images/datagatewayph.com.png",
      link: "https://www.datagatewayph.com/",
    },
    {
      title: "H&E Comfort Services",
      subtitle: "WordPress + Elementor",
      description:
        "H&E Comfort Services is a full-service HVAC company providing quality heating and cooling services to homeowners in the New Orleans area.",
      image: "./images/hecomfortservices.com.png",
      link: "https://www.hecomfortservices.com/",
    },
    {
      title: "The Jewelry Forum",
      subtitle: "WordPress + Elementor",
      description:
        "We are an online jewelry reviews platform, bringing jewelry shoppers and sellers together.",
      image: "./images/thejewelryforum.com.png",
      link: "https://thejewelryforum.com/",
    },
    {
      title: "The Influencer Forum",
      subtitle: "WordPress + Elementor",
      description:
        "Influencer Forum is here to help you with influencer marketing agencies, reviews, brand management.",
      image: "./images/theinfluencerforum.com.png",
      link: "https://theinfluencerforum.com/",
    },
  ];
  
  
export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "WordPress",
  "PHP",
  "jQuery",
  "CSS",
  "HTML",
  "MySQL",
  "Woocommerce",
  "Elementor",
  "Tailwind CSS",
  "React JS",
  "Shopify",
];
